import { isNull } from '../../util'

import { normalizeReferenceNumber } from './normalizeReferenceNumber'

//
// 変換マスタ（ShapeNameConversion）による表示上の名寄せ。
// 発注データ側の表記を正とし、ミルシート側の品名・サイズ・長さを発注データ側の表記に変換して「表示」する
// （照合・ステータス判定には一切使わない。2026/07/13-14 ヒアリング回答。
// docs/domain/order_matching/04_matching_logic.md）。
//

export const SHAPE_NAME_CONVERSION_FIELDS = ['productName', 'size', 'length'] as const
export type ShapeNameConversionFieldValue = (typeof SHAPE_NAME_CONVERSION_FIELDS)[number]

export const shapeNameConversionFieldLabel: Record<ShapeNameConversionFieldValue, string> = {
  productName: '品名',
  size: 'サイズ',
  length: '長さ',
}

// sourceValue（ミルシート側の表記）は正規化した値で保存・突合する（docs/domain/order_matching/03_data_model.md）。
// 正規化の内容は参照番号と同じ（全角/半角統一・大文字化・前後空白除去）。
// ミルシートの表示値そのものは変換しない限り原文のまま出すため、この正規化は辞書引きのキーにだけ使う
export function normalizeShapeNameConversionSourceValue(value: string): string {
  return normalizeReferenceNumber(value)
}

export type ShapeNameConversionDisplayMap = ReadonlyMap<string, string>

function displayMapKey(field: ShapeNameConversionFieldValue, sourceValue: string): string {
  return `${field}:${normalizeShapeNameConversionSourceValue(sourceValue)}`
}

export function buildShapeNameConversionDisplayMap(
  conversions: ReadonlyArray<{
    field: ShapeNameConversionFieldValue
    sourceValue: string
    normalizedValue: string
  }>,
): ShapeNameConversionDisplayMap {
  return new Map(conversions.map((x) => [displayMapKey(x.field, x.sourceValue), x.normalizedValue]))
}

// ミルシート側の表示値を発注データ側の表記へ変換する。辞書に無い値はそのまま返す
export function convertShapeNameForDisplay(
  map: ShapeNameConversionDisplayMap,
  field: ShapeNameConversionFieldValue,
  value: string | null | undefined,
): string | null {
  if (isNull(value)) {
    return null
  }
  // 空文字は辞書のキーになりえない（sourceValue は必須入力）ため、そのまま返る
  return map.get(displayMapKey(field, value)) ?? value
}
